var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: { label: _vm.label, "class-name": _vm.formLabelClassName },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "textarea",
                _vm._b(
                  {
                    ref: "component",
                    staticClass: "pega-form-item",
                    class: _vm.className,
                    attrs: {
                      placeholder: _vm.placeholder,
                      "data-test": "item",
                    },
                    domProps: { value: _vm.value },
                    on: { input: _vm.update },
                  },
                  "textarea",
                  _vm.$attrs,
                  false
                )
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [_vm._t("error")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }